import { Dispatch, SetStateAction, useCallback } from 'react'

import { useConfigsContext } from '@/context/ConfigsContext'
import useGetCommunityToggle from '@/hooks/auth/useGetCommunityToggle'
import { createProfile, createViveportAuth, getHtcAuthKey } from '@/lib/auth'
import { getProfileMe } from '@/services/auth'
import { HubsStore } from '@/types/store'

export const useHandleGeneralProfile = (setIsSignedIn: Dispatch<SetStateAction<boolean>>) => {
  const { setStore } = useConfigsContext()
  const getCommunityToggle = useGetCommunityToggle()

  return useCallback(async () => {
    const htcAuthKey = await getHtcAuthKey()

    if (!htcAuthKey) {
      setIsSignedIn(false)
      return
    }

    const result = await getProfileMe(htcAuthKey)
    if (!result) {
      throw new Error('Error while fetching profile')
    }

    const credentials = {
      htcToken: htcAuthKey,
    } as HubsStore['credentials']

    const profile = createProfile(result)
    const viveportAuth = createViveportAuth(result)
    const communityToggle = await getCommunityToggle(credentials)

    setStore((value) => ({
      ...value,
      viveportAuth: {
        ...value.viveportAuth,
        ...viveportAuth,
      },
      profile: {
        ...value.profile,
        ...profile,
      },
      communityToggle,
      credentials: {
        ...value.credentials,
        ...credentials,
      },
    }))

    setIsSignedIn(true)
  }, [getCommunityToggle, setIsSignedIn, setStore])
}
